import { FileExportResponse } from '../../models/FIleModels';
import { PaginationResponse } from '../../models/PaginatedModels';
import { SystemOperationRecordResponse, GetSystemOperationRecordPaginationRequest } from '../../models/SystemOpsModels';
import { baseApiService } from '../baseApiService';

export const systemOperationsAPI = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        getSystemOperationRecords: builder.query<
            PaginationResponse<SystemOperationRecordResponse>,
            GetSystemOperationRecordPaginationRequest
        >({
            query: (req) => {
                const params = new URLSearchParams();

                if (req.pageNumber !== undefined) {
                    params.append('pageNumber', req.pageNumber.toString());
                }

                if (req.pageSize !== undefined) {
                    params.append('pageSize', req.pageSize.toString());
                }

                if (req.type !== null && req.type !== undefined) {
                    params.append('type', req.type.toString());
                }

                if (req.occuredAtFrom) {
                    params.append('from', req.occuredAtFrom);
                }

                if (req.occuredAtTo) {
                    params.append('to', req.occuredAtTo);
                }

                return {
                    url: `/v1/systemoperationrecord?${params.toString()}`,
                    method: 'GET',
                };
            },
        }),

        exportSystemOperationRecords: builder.mutation<
            FileExportResponse,
            Pick<GetSystemOperationRecordPaginationRequest, 'type' | 'occuredAtFrom' | 'occuredAtTo'>
        >({
            query: (req) => {
                const params = new URLSearchParams();

                if (req.type !== null && req.type !== undefined) {
                    params.append('type', req.type.toString());
                }

                if (req.occuredAtFrom) {
                    params.append('from', req.occuredAtFrom);
                }

                if (req.occuredAtTo) {
                    params.append('to', req.occuredAtTo);
                }

                return {
                    url: `/v1/systemoperationrecord/export?${params.toString()}`,
                    method: 'POST',
                };
            },
        }),
    }),
});

export const {
    useExportSystemOperationRecordsMutation,
    useGetSystemOperationRecordsQuery,
    useLazyGetSystemOperationRecordsQuery,
} = systemOperationsAPI;